// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3x9XM","modal":"Modal_modal__Czjg6","slide-down":"Modal_slide-down__wbEWd"};